import { createAPI } from '@common'

export default {
  // 三方账号列表（临时演示用
  getVideosAccounts: (config, vConfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfwjefp0we0bddpvout', 'get', config, vConfig)
}
